var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 58,
    viewBox: "0 0 220 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.557 27.7775C45.7396 -23.4501 0.0918674 6.52468 -18 35.2492V101H275V42.7209C251.613 63.9737 174.392 64.6378 120.557 27.7775Z",
    fill: "#2B2B2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -18,
    y1: -5.11345,
    x2: 184.437,
    y2: 193.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991396,
    stopColor: "#4C4C4C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackWave);
export default __webpack_public_path__ + "static/media/black_wave.8a87c082d58fd642c8c2eeae61c8bad4.svg";
export { ForwardRef as ReactComponent };